// frontend_react/src/App.jsx

import React, { useEffect } from "react";
import { getSocket } from "./services/socket";
import AppRoutes from "./AppRoutes";
import { useLogin } from "./context/LoginContext";

export default function App() {
  const { authLoading } = useLogin();

  useEffect(() => {
    if (authLoading) return;

    const socket = getSocket();

    const onConnect = () => {
      console.log("✅ CONNECTED", socket.id);
    };

    const onNewTicket = (data) => {
      console.log("🔥 NEW TICKET", data);
    };

    const onError = (err) => {
      console.error("❌ SOCKET ERROR", err);
    };

    socket.on("connect", onConnect);
    socket.on("kitchen:new_ticket", onNewTicket);
    socket.on("connect_error", onError);

    return () => {
      socket.off("connect", onConnect);
      socket.off("kitchen:new_ticket", onNewTicket);
      socket.off("connect_error", onError);
    };
  }, [authLoading]);

  if (authLoading) {
    return <div style={{ color: "white" }}>⏳ Authentification en cours...</div>;
  }

  return <AppRoutes />;
}